/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const getDentistListAction = createAction('REFORAL_GET_DENTIST_LIST');
export const getMyClinicListAction = createAction('REFORAL_GET_MY_CLINIC_LIST');
export const getAffiliatedDentistListAction = createAction('REFORAL_GET_AFFILIATED_DENTIST_LIST');
export const deleteAffiliatedClinicAction = createAction('REFORAL_DELETE_AFFILIATED_CLINIC');
export const declineDentistInviteAction = createAction('REFORAL_DECLINE_DENTIST_INVITE');
export const acceptDentistInviteAction = createAction('REFORAL_ACCEPT_DENTIST_INVITE');
export const getReferralFilterDentistListAction = createAction('REFORAL_GET_REFERRAL_FILTER_DENTIST_LIST');
export const getReferralFilterListAction = createAction('REFORAL_GET_REFERRAL_FILTER_LIST');

export const updateMyClinicInvitesCountAction = createAction('REFORAL_UPDATE_MY_CLINIC_INVITES_COUNT');
